// extracted by mini-css-extract-plugin
export default {"mainContainer":"skills_management-module___mainContainer___aa0b0fa1"};